/**
 * User roles in the system.
 */
export var Role;
(function (Role) {
    Role["KASMADMIN"] = "License Server Kasm Super Admin";
    Role["KASMACCESS"] = "License Server Access";
})(Role || (Role = {}));
